<template>
	<div class="container">
		<div class="text-box">
			{{ $t('_nombre_d_alarmes_') }}
			<ul class="Liste">
				<li>{{ $t('_traitees_') }} <div class="rondBleu"> {{ submitted }} </div>
				</li>
				<li>{{ $t('_en_cours_de_traitement_') }} <div class="rondJaune"> {{ pendings }} </div>
				</li>
				<li>{{ $t('_non_traitees_') }} <div class="rondRouge"> {{ todos }} </div>
				</li>
			</ul>
		</div>
		<v-btn class="button" @click="toggleAlarmCreate">{{ $t('_ajouter_une_alarme_') }}</v-btn>
		<div class="mapContainer">
			<l-map ref="refMap" class="small-map" :zoom="zoom" :center="center" @update:zoom="zoomUpdated"
				@update:center="centerUpdated" @update:bounds="boundsUpdated">
				<custom-tile-layer :url="tileProviders.url" :attribution="tileProviders.attribution" :maxZoom="22"
					:maxNativeZoom="18" />
				<l-feature-group ref="featureGroup" />

			</l-map>
			<Info v-if="modalState" :linkedMpps="modalMpp" :idBloc="modalBloc" :alarms="selectedBlockAlarm" :answers="selectedBlockAnswer"
				@close="closeModal()" @update="update()" />
			<PopUpNewAlarm v-if="creerAlarme" :geoLoc="geoLoc" @close="toggleAlarmCreate"></PopUpNewAlarm>
		</div>
	</div>
</template>

<script>
import { LMap, LFeatureGroup } from 'vue2-leaflet';

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import 'leaflet-toolbar/dist/leaflet.toolbar.css'
import 'leaflet-toolbar';

import 'leaflet-distortableimage'
import 'leaflet-distortableimage/dist/leaflet.distortableimage.css'

import 'leaflet.locatecontrol';
import api from "@/api/api";
import backend from '@/api/backend';
import Info from '../../components/Tech/PopUpInfo.vue';
import PopUpNewAlarm from '@/components/Tech/PopUpNewAlarm.vue';

const CustomTileLayer = {
	name: 'CustomTileLayer',
	props: ['url', 'attribution', 'maxZoom', 'maxNativeZoom'],
	mounted() {
		const tileLayer = L.tileLayer(this.url, {
			attribution: this.attribution,
			maxZoom: this.maxZoom,
			maxNativeZoom: this.maxNativeZoom,
			noWrap: true,
			tms: false,
		});

		tileLayer.addTo(this.$parent.mapObject);
	},
	render() {
		return null;
	}
};

export default {
	components: { LMap, CustomTileLayer, LFeatureGroup, Info, PopUpNewAlarm },

	async mounted() {
		await this.fetchAlarms();
		await this.fetchAndCountAlarmsAnswers();
		await this.fetchContours();
		await this.fetchRectanglesMpp();
		try {
			api.get_layout_model_global_info(this.installation_id).then((res) => {
				this.markerLatLng = [res.data.latitude, res.data.longitude]
			})
		}
		catch {
			const res = (await backend.get_install_form(this.installation_id)).data

			const description = res.description
			this.markerLatLng = [parseFloat(description.markerLatLng0), parseFloat(description.markerLatLng1)]
		}
		try {

			let corners = (await backend.get_mask_install(this.installation_id)).data

			let fileURL = URL.createObjectURL((await backend.get_mask_file_install(this.installation_id)).data)


			const map = this.$refs.refMap.mapObject

			const options = {
				corners: corners,
				suppressToolbar: true,
				editable: false,
				actions: [],
				mode: ''
			}

			this.overlay = L.distortableImageOverlay(fileURL, options).addTo(map)
			this.imageExiste = true
			URL.revokeObjectURL(fileURL);
		}
		catch (error) {
			console.error("Pas d'image à recuperer", error)
		}
		this.$refs.refMap.mapObject.locate({ setView: false, maxZoom: 30 });
		this.$refs.refMap.mapObject.on('locationfound', this.onLocationFound);
		this.$refs.refMap.mapObject.on('locationerror', this.onLocationError);
	},

	data() {
		return {
			installation_id: this.$route.params.id,
			// highlightedMpp: this.$route.query.highlightMpp,
			url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
			zoom: 17,
			markerLatLng: [0, 0],
			center: [48.866667, 2.333333],
			mapRef: null,
			bounds: null,

			tileProviders:
			{
				url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png",
				visible: true,
				name: "satelliteESRI",
				attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
			},

			mpps: [],
			polygonCoords: [],
			rectangles: [],
			mpp_assigned: [],
			modalState: false,
			alarmsJSON: [],
			selectedBlockAlarm: [],
			alarmsAnswersJSON: [],
			selectedBlockAnswer: [],
			todos: 0,
			pendings: 0,
			submitted: 0,
			creerAlarme: false,
			geoLoc: null,
			modalBloc: null,
			modalMpp: null
		};
	},


	watch: {
		isLoaded() {
			this.$forceUpdate();
		},
	},


	methods: {
		async fetchContours() {
			try {
				const response = await backend.get_edges_install(this.installation_id);
				this.polygonCoords = response.data;
				await this.$nextTick();

			} catch (err) {
				console.error("Pas de données géospatiale pour ce site")
			}
		},

		async fetchRectanglesMpp() {
			try {
				const [response1, response2] = await Promise.all([backend.get_blocs_install(this.installation_id), backend.get_m_pts_install(this.installation_id)]);
				this.rectangles = response1.data;
				this.mpp_assigned = response2.data;

				await this.$nextTick();

			} catch (err) {
				this.rectangles = [];
				this.mpp_assigned = [];
			}
			this.initPolygons();
		},

		async fetchAlarms() {
			try {
				const response = await backend.get_alarmquery_install(this.installation_id);
				this.alarmsJSON = response.data
			} catch (err) {
				console.log("Couldn't fetch alarms")
			}
		},

		async fetchAndCountAlarmsAnswers() {
			try {
				const response = await backend.get_alarm_install(this.installation_id);
				this.alarmsAnswersJSON = response.data
			} catch (err) {
				console.log("No answer")
			}
			this.todos = 0
			this.pendings = 0
			this.submitted = 0
			for (var x in this.alarmsJSON) {
				const id = this.alarmsJSON[x].id
				if (this.alarmsAnswersJSON[this.getAnswerIndex(id)] === undefined) {
					this.todos += 1
				}
				else if (this.alarmsAnswersJSON[this.getAnswerIndex(id)].json_data['field_alarm_status'] === "In Progress") {
					this.pendings += 1
				}
				else if (this.alarmsAnswersJSON[this.getAnswerIndex(id)].json_data['field_alarm_status'] === "Submitted") {
					this.submitted +=1
				}
			}
		},

		initPolygons() {
			const poly = L.polygon(this.polygonCoords);
			this.$refs.refMap.mapObject.fitBounds(poly.getBounds());
			this.rectangles.forEach((rectangle, index) => {
				this.addPolygonToLayer(rectangle, this.mpp_assigned[index], index);
			});
		},

		refresHeader() {
		},
		zoomUpdated(zoom) {
			this.zoom = zoom;
		},
		centerUpdated(center) {
			this.center = center;
		},
		boundsUpdated(bounds) {
			this.bounds = bounds;
		},

		addPolygonToLayer(rectangle, mpp, index) {
			const polygon = L.polygon(rectangle);
			polygon.options.mpp = mpp;
			polygon.id = index
			polygon.on('click', () => {
				this.openModal(polygon);
			});
			polygon.setStyle(this.getStylePolygon(polygon));
			this.$refs.featureGroup.mapObject.addLayer(polygon);
		},

		openModal(polygon) {
			this.selectedBlockAlarm = [];
			this.selectedBlockAnswer = [];
			polygon.options.mpp.forEach((element) => {
				this.alarmsJSON.forEach((alarm) => {
					if ((alarm.datapoint !== "") && (alarm.datapoint === "mpp-" + element || alarm.datapoint === "inv-" + element[0])) {
						if (this.selectedBlockAlarm.indexOf(alarm) === -1) {
							this.selectedBlockAlarm.push(alarm)
						}
						const answer = this.alarmsAnswersJSON[this.getAnswerIndex(alarm.id)]
						if (answer !== undefined && this.selectedBlockAnswer.indexOf(answer) === -1) {
							this.selectedBlockAnswer.push(answer)
						}
					}
				})
			})
			this.alarmsJSON.forEach((alarm) => {
					if ((alarm.bloc_id !== null) && (alarm.bloc_id.length > 0) && (alarm.bloc_id.includes(polygon.id))) {
						if (this.selectedBlockAlarm.indexOf(alarm) === -1) {
							this.selectedBlockAlarm.push(alarm)
						}
						const answer = this.alarmsAnswersJSON[this.getAnswerIndex(alarm.id)]
						if (answer !== undefined && this.selectedBlockAnswer.indexOf(answer) === -1) {
							this.selectedBlockAnswer.push(answer)
						}
					}
				})
			this.modalState = true;
			this.modalMpp = polygon.options.mpp;
			this.modalBloc= polygon.id
		},
		getAnswerIndex(alarmId) {
			for (var answer in this.alarmsAnswersJSON) {
				if (this.alarmsAnswersJSON[answer].id === alarmId) {
					return answer
				}
			}
		},
		closeModal() {
			this.modalState = false;
		},

		getStylePolygon(layer) {
			let match = ""
			let highlighted = false
			let color
			let fcolor
			let fopa
			let highlightedMpp = this.$route.query.mpp
			let highlightedBloc = this.$route.query.bloc
			layer.options.mpp.forEach((element) => {
				this.alarmsJSON.forEach((alarm) => {
					if ((alarm.datapoint !== "") && (alarm.datapoint === "mpp-" + element || alarm.datapoint === "inv-" + element[0])) {
						if (this.alarmsAnswersJSON[this.getAnswerIndex(alarm.id)] !== undefined && match !== "To do") {
							match = this.alarmsAnswersJSON[this.getAnswerIndex(alarm.id)].json_data['field_alarm_status']
						}
						else {
							match = "To do"
						}

					}
					else if ((alarm.bloc_id !== null) && (alarm.bloc_id.length > 0) && (alarm.bloc_id.indexOf(layer.id) !== -1)) {
						if (this.alarmsAnswersJSON[this.getAnswerIndex(alarm.id)] !== undefined && match !== "To do") {
							match = this.alarmsAnswersJSON[this.getAnswerIndex(alarm.id)].json_data['field_alarm_status']
						}
						else {
							match = "To do"
						}
					}
				})
				
				if (highlightedMpp != undefined && (highlightedMpp === "mpp-" + element || highlightedMpp === "inv-" + element[0])) {
					highlighted = true
				}
			})
			this.alarmsJSON.forEach((alarm) => {
					if ((alarm.bloc_id !== null) && (alarm.bloc_id.length > 0) && (alarm.bloc_id.indexOf(layer.id) !== -1)) {
						if (this.alarmsAnswersJSON[this.getAnswerIndex(alarm.id)] !== undefined && match !== "To do") {
							match = this.alarmsAnswersJSON[this.getAnswerIndex(alarm.id)].json_data['field_alarm_status']
						}
						else {
							match = "To do"
						}
					}
				})
			if (highlightedBloc !== undefined) {
				highlightedBloc.forEach((bloc) => {
					if (bloc === layer.id) {
						highlighted = true
					}
				})
			}



			if (match === "To do") {
				color = '#CF0000'
				fcolor = '#CF0000'
				fopa = 0.3
			}
			else if (match === "In Progress") {
				color = '#FFE97C'
				fcolor = '#FFE97C'
				fopa = 0.3
			}
			else {
				color = '#4063fd'
				fcolor = '#4063fd'
				fopa = 0.2
			}
			if (highlighted === true)
				fopa = 0.8
			return {
				color: color,
				fillColor: fcolor,
				fillOpacity: fopa,
			}

		},

		onLocationFound(e) {
			var radius = e.accuracy;

			L.circleMarker(e.latlng, {
				radius: 5,           // en pixels
				color: '#00C51D',
				fillColor: '#00C51D',
				fillOpacity: 1
			}).addTo(this.$refs.refMap.mapObject)

			L.circle(e.latlng, {
				radius: radius,
				color: '#00C51D',
				fillColor: '#00C51D',
				opacity: 0.3,
				fillOpacity: 0.1
			}).addTo(this.$refs.refMap.mapObject);

			this.geoLoc.push(e.latlng.lat)
			this.geoLoc.push(e.latlng.lng)
		},

		onLocationError(e) {
			alert(e.message);
		},

		async toggleAlarmCreate() {
			await this.update()
			this.creerAlarme = !this.creerAlarme
		},

		async update() {
			this.isLoaded = false
			await this.fetchAlarms();
			await this.fetchAndCountAlarmsAnswers();
			const polygs = this.$refs.featureGroup.mapObject._layers
			Object.values(polygs).forEach((polygon) => {
				polygon.setStyle(this.getStylePolygon(polygon));
			})
			this.isLoaded = true
			this.$forceUpdate()
		}
	}
};
</script>

<style scoped>
.small-map {
	height: 100%;
	width: 100%;
	aspect-ratio: 1 / 1;
	z-index: 0;
}

.container {
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	height: 90vh;
	justify-content: center;
	/* align-content: center; */
}

.button {
	/* all: unset; */
	max-width: 30%;
	margin-left: 5%;
	margin-top: 3%;
	min-height: 4vh;
	margin-right: 0;
	white-space: unset;
	display: unset;
	height: fit-content !important;
	background-color: #D9D9D9;

}
.button .v-btn__content {
  /* white-space: normal; */
  word-wrap: break-word;
  overflow-wrap: break-word;
  display: block;
  text-align: center; /* Optionnel */
  white-space: pre-wrap;
}

.mapContainer {
	display: flex;

	height: 80%;
	width: 90%;
	margin-top: 2%;

}

.text-box {
	width: 60%;
	margin-left: 5%;
	margin-top: 3%;
	/* background-color: rgb(169, 117, 218); */
	box-sizing: border-box;
	height: fit-content;

}

.liste {
	list-style: circle;
}

.rondJaune {
	background-color: #FFE97C;
	display: inline-flex;
	/* float: right; */
	margin-right: 2%;
	height: 25px;
	width: 25px;
	border-radius: 50%;
	justify-content: center;
}

.rondRouge {
	background-color: #CF0000a9;
	display: inline-flex;
	/* float: right; */
	margin-right: 2%;
	height: 25px;
	width: 25px;
	border-radius: 50%;
	justify-content: center;
}

.rondBleu {
	background-color: #4063fda9;
	display: inline-flex;
	/* float: right; */
	margin-right: 2%;
	height: 25px;
	width: 25px;
	border-radius: 50%;
	justify-content: center;
}

</style>